import { main } from '@popperjs/core';
import { scroller } from './smoothScroll';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { ScrollTrigger, DrawSVGPlugin } from 'gsap/all';
import { SplitText } from 'gsap/SplitText';
import { head } from 'underscore';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);

export default (els) => {
    Array.prototype.forEach.call(els, (el) => {

        const brow = el.querySelector('.map__brow > span');
        const heading = el.querySelector('.map__heading >h2');
        const subtext = el.querySelector('.map__subtext > p');
        const verticalRule = el.querySelector('.map--vertical-rule');

        const mainland = el.querySelector('.map--mainland');
        const mapPoints = el.querySelectorAll('.map__locations-group > text');

        const statIcons = el.querySelectorAll('.map--stat-icon-group > *');
        console.log(statIcons)
        gsap.set(verticalRule, { transformOrigin: 'center top' })

        let splitText = new SplitText([brow, heading, subtext], { type: "words,chars" });

        gsap.set(mainland, {
            attr: { 'fill-opacity': 0.2 }
        })

        gsap.set(mapPoints, {
            attr: { 'fill-opacity': 0, y: 100 }
        })

        gsap.from(verticalRule, {
            scaleY: 0,
            opacity: 0,
            duration: 1,
            scrollTrigger: {
                trigger: el,
                start: 'top 70%',
                end: 'top 20%',
                scrub: 1,
                markers: false
            }
        });

        gsap.from(splitText.chars, {
            opacity: 0.2,
            stagger: 0.05,
            duration: 1,
            scrollTrigger: {
                trigger: el,
                start: 'top 70%',
                end: 'top 20%',
                scrub: 1,
                markers: false
            }
        });

        gsap.to(mainland, {
            attr: { 'fill-opacity': 1 },
            duration: 1,
            scrollTrigger: {
                trigger: mainland,
                start: 'top 70%',
                end: 'top 20%',
                scrub: 1,
                markers: false
            }
        })

        gsap.to(mapPoints, {
            attr: { 'fill-opacity': 1, y: 0 },
            duration: 2,
            stagger: 1,
            ease: Power1.easeInOut,
            scrollTrigger: {
                trigger: mainland,
                start: 'top 80%',
                end: 'bottom 80%',
                scrub: 1,
                markers: false
            }
        });



        // statIcons.forEach((node) => {

        //     console.log(node)
        //     gsap.from(node, {
        //         duration: 1,
        //         drawSVG: 0,
        //         scrollTrigger: {
        //             trigger: statIcons,
        //             start: 'bottom 40%',
        //             end: 'bottom 10%',
        //             scrub: 1,
        //             markers: true
        //         }
        //     })

        // })

        gsap.from('.stat', {
            duration: 1,
            opacity: 0,
            y: "+=30",
            stagger: 0.5,
            scrollTrigger: {
                trigger: mainland,
                start: 'top 40%',
                end: 'top 20%',
                scrub: 1,
                markers: false
            }
        })


    });

}